const MIDDLE_PANEL_TAB_NAMES = {
  JOURNEY: 'Journey',
  WORKFLOWS: 'Action Items',
  ATTACHMENTS: 'Attachments',
};

export { MIDDLE_PANEL_TAB_NAMES };
